"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));

var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    avatar: {
      display: "none",
      left: theme.spacing(2),
      position: "absolute",
      top: theme.spacing(2)
    }
  };
});

var Author = function Author(_ref) {
  var firstname = _ref.firstname,
      lastname = _ref.lastname,
      imageSmall = _ref.imageSmall;
  var REACT_APP_PATH = process.env.REACT_APP_PATH;
  var css = useStyles();
  return /*#__PURE__*/_react.default.createElement(_Avatar.default, {
    alt: firstname + " " + lastname,
    className: css.avatar,
    src: REACT_APP_PATH + imageSmall
  });
};

var _default = Author;
exports.default = _default;